import { render } from "./AddToCollectionCard.vue?vue&type=template&id=6e405e24&scoped=true"
import script from "./AddToCollectionCard.vue?vue&type=script&lang=js"
export * from "./AddToCollectionCard.vue?vue&type=script&lang=js"

import "./AddToCollectionCard.vue?vue&type=style&index=0&id=6e405e24&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e405e24"]])

export default __exports__